import React, { useState, useEffect } from 'react';
import { Select, Space } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const CurrencySelector = ({ style = {}, compact = false }) => {
  const [selectedCurrency, setSelectedCurrency] = useState('EUR');
  const { t } = useTranslation();

  const currencies = [
    { code: 'EUR', symbol: '€', flag: '🇪🇺' },
    { code: 'USD', symbol: '$', flag: '🇺🇸' },
    { code: 'GBP', symbol: '£', flag: '🇬🇧' },
  ];

  // Charger la devise sauvegardée au démarrage
  useEffect(() => {
    const savedCurrency = localStorage.getItem('selectedCurrency');
    if (savedCurrency) {
      setSelectedCurrency(savedCurrency);
    }
  }, []);

  const handleCurrencyChange = (currencyCode) => {
    setSelectedCurrency(currencyCode);
    // Sauvegarder dans localStorage
    localStorage.setItem('selectedCurrency', currencyCode);
    
    // Émettre un événement personnalisé pour notifier le changement de devise
    window.dispatchEvent(new CustomEvent('currencyChanged', { 
      detail: { 
        currency: currencyCode,
        currencyData: currencies.find(c => c.code === currencyCode)
      } 
    }));
  };

  return (
    <Space style={style}>
      {!compact && <DollarOutlined />}
      <Select
        value={selectedCurrency}
        style={{ width: compact ? 120 : 180 }}
        onChange={handleCurrencyChange}
        size="small"
        placeholder={t('common.currency')}
      >
        {currencies.map(currency => (
          <Option key={currency.code} value={currency.code}>
            <Space>
              <span>{currency.flag}</span>
              <span>{currency.symbol}</span>
              <span>{currency.code}</span>
              {!compact && <span style={{ color: '#666' }}>- {t(`currencies.${currency.code}`)}</span>}
            </Space>
          </Option>
        ))}
      </Select>
    </Space>
  );
};

export default CurrencySelector;
